<template>
  <div v-if="post.youtubeId" class="trailer-section glass-card pa-6 mb-6">
    <div class="d-flex align-center ga-2 mb-4">
      <v-icon color="#ef4444" size="22">mdi-youtube</v-icon>
      <h3 class="text-subtitle-1 font-weight-bold mb-0">Official Trailer</h3>
    </div>
    <div class="video-cinema-container">
      <iframe
        :src="`https://www.youtube.com/embed/${post.youtubeId}`"
        title="Movie trailer"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="video-iframe"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MovieYouTube',
  props: {
    post: { type: Object, required: true },
  },
}
</script>

<style scoped>
.video-cinema-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
  background: #000;
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>

